import { EventCategory, FilterInput, FilterOperator } from '@kinetic-ui/data-layer';

const roadConditionFilter = {
  value: EventCategory.RoadCondition,
  operator: FilterOperator.NotEquals,
  field: 'category',
};

const scheduledEventFilter = {
  value: EventCategory.ScheduledEvent,
  operator: FilterOperator.NotEquals,
  field: 'category',
};

export const filterEvents = (additionalFilters?: FilterInput[]) => {
  return [roadConditionFilter, scheduledEventFilter, ...(additionalFilters ?? [])];
};
